import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function LeadSection() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="py-24 bg-white relative overflow-hidden" data-id="element-141">
      {/* Subtle texture overlay */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/subtle-paper.png')] opacity-40" data-id="element-142"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center relative z-10" data-id="element-143">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-144">
          <p className="font-serif italic text-accent text-xl md:text-2xl mb-6 font-medium" data-id="element-145">
            Mira tus manos por un momento...
          </p>

          <div className="space-y-8 text-lg md:text-xl text-brown-light leading-relaxed font-sans" data-id="element-146">
            <p data-id="element-147">
              Esas manos han criado familias.
              <br data-id="element-148" />
              Han cocinado recetas que todos aman.
              <br data-id="element-149" />
              Han cosido sueños y cuidado de otros por décadas.
            </p>
            <p data-id="element-150">
              Esas manos guardan un tesoro que el mercado americano está
              desesperado por comprar.
            </p>
            <p data-id="element-151">
              Pero, hasta ahora, te han dicho que para tener un negocio
              necesitas ser un genio de las computadoras.
            </p>
            <p data-id="element-152">Que necesitas hablar un inglés perfecto.</p>
            <p data-id="element-153">O invertir miles de dólares que no tienes.</p>

            <div className="py-12 relative" data-id="element-154">
              <div className="absolute left-1/2 -translate-x-1/2 top-0 w-24 h-[1px] bg-accent/30" data-id="element-155"></div>
              <motion.h2 initial={{
              scale: 0.8,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.8,
              type: 'spring'
            }} className="text-5xl md:text-7xl font-serif font-bold text-pink-gradient leading-tight tracking-tight" data-id="element-156">
                Te mintieron.
              </motion.h2>
              <div className="absolute left-1/2 -translate-x-1/2 bottom-0 w-24 h-[1px] bg-accent/30" data-id="element-157"></div>
            </div>

            <p className="font-serif italic text-2xl text-brown-light" data-id="element-158">
              En este país, lo artesanal es lujo.
              <br data-id="element-159" />
              <span className="font-bold text-brown" data-id="element-160">
                Y tú eres la maestra.
              </span>
            </p>

            <p data-id="element-161">
              Solo te falta el puente entre tu mesa de trabajo y el dinero en tu
              cuenta de Zelle.
            </p>

            <p className="text-brown font-bold text-xl" data-id="element-162">
              Ese puente es el Método 'Hogar Dorado'.
            </p>

            {/* Cost of Inaction */}
            <div className="mt-16 bg-accent/5 border-l-4 border-accent rounded-r-2xl p-8 text-left shadow-sm" data-id="element-163">
              <p className="text-brown font-serif italic text-lg md:text-xl leading-relaxed" data-id="element-164">
                "¿Cuánto dinero has dejado ir este año por no saber cómo vender?
                ¿Cuántas veces has tenido que pedir dinero a tus hijos o esposo
                sintiendo ese nudo en la garganta?{' '}
                <span className="font-bold not-italic text-accent" data-id="element-165">
                  Eso termina hoy.
                </span>
                "
              </p>
            </div>

            <div className="mt-12" data-id="element-166">
              <Button variant="outline" onClick={scrollToOffer} className="border-accent text-accent hover:bg-accent/5" data-id="element-167">
                Quiero aprender a vender hoy
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-168" />
              </Button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}